import * as types from './mutation-types'
import {
  API_STATES
} from '@/helpers'
import {
  updateField
} from 'vuex-map-fields';
import {
  merge
} from 'lodash'


const mutations = {

  updateField,

  // getSchedules
  [types.GET_SCHEDULES_BEGIN](state) {
    state.workSchedulesState = API_STATES.REQUEST_PENDING
  },
  [types.GET_SCHEDULES_SUCCESS](state, store) {
    state.workSchedulesError = null
    state.workSchedules = store
    state.workSchedulesState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_SCHEDULES_ERROR](state, err) {
    state.workSchedulesState = API_STATES.REQUEST_ERROR
    state.workSchedulesError = err
  },

  // getEmployeesFilterData
  [types.GET_EMPLOYEES_FILTER_BEGIN](state) {
    state.employeesFilterState = API_STATES.REQUEST_PENDING
  },
  [types.GET_EMPLOYEES_FILTER_SUCCESS](state, store) {
    state.employeesFilter = store.employees
    state.employeesFilterState = API_STATES.REQUEST_SUCCESS
    state.employeesFilterError = null
  },
  [types.GET_EMPLOYEES_FILTER_ERROR](state, err) {
    state.employeesFilterState = API_STATES.REQUEST_ERROR
    state.employeesFilterError = err
  },

  // getPositionsFilterData
  [types.GET_POSITION_FILTER_BEGIN](state) {
    state.positionsFilterState = API_STATES.REQUEST_PENDING
  },
  [types.GET_POSITION_FILTER_SUCCESS](state, company) {
    state.positionsFilter = company.positions
    state.positionsFilterState = API_STATES.REQUEST_SUCCESS
    state.positionsFilterError = null
  },
  [types.GET_POSITION_FILTER_ERROR](state, err) {
    state.positionsFilterState = API_STATES.REQUEST_ERROR
    state.positionsFilterError = err
  },

  [types.GET_STORE_ACTIVE_EMPLOYEES_BEGIN](state) {
    state.storeActiveEmployeesGetState = API_STATES.REQUEST_PENDING
  },
  [types.GET_STORE_ACTIVE_EMPLOYEES_SUCCESS](state, employees) {
    state.storeActiveEmployees = employees
    state.storeEmployeesHavingMailId = employees.filter(e => !!e.email)
    state.storeEmployeesHavingCellNumber = employees
      .filter(e => !!e.cell_phone)
    state.storeActiveEmployeesGetState = API_STATES.REQUEST_SUCCESS
    state.storeActiveEmployeesGetError = null
  },
  [types.GET_STORE_ACTIVE_EMPLOYEES_FAILED](state, err) {
    state.storeActiveEmployeesGetState = API_STATES.REQUEST_ERROR
    state.storeActiveEmployeesGetError = err
  },

  [types.SEND_EMAIL_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_BEGIN](state) {
    state.sendEmailWeeklyWorkSchedulesToEmployeesState = API_STATES
      .REQUEST_PENDING
  },
  [types.SEND_EMAIL_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_SUCCESS]
  (state, message) {
    state.sendEmailWeeklyWorkSchedulesToEmployeesError = null
    state.weeklyWorkSchedulesEmailSentSuccessMessage = message
    state.sendEmailWeeklyWorkSchedulesToEmployeesState = API_STATES
      .REQUEST_SUCCESS
  },
  [types.SEND_EMAIL_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_FAILED](state, err) {
    state.sendEmailWeeklyWorkSchedulesToEmployeesError = err
    state.sendEmailWeeklyWorkSchedulesToEmployeesState = API_STATES
      .REQUEST_ERROR
  },
  [types.SEND_SMS_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_BEGIN](state) {
    state.sendSmsWeeklyWorkSchedulesToEmployeesState = API_STATES
      .REQUEST_PENDING
  },
  [types.SEND_SMS_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_SUCCESS]
  (state, message) {
    state.sendSmsWeeklyWorkSchedulesToEmployeesError = null
    state.weeklyWorkSchedulesSmsSentSuccessMessage = message
    state.sendSmsWeeklyWorkSchedulesToEmployeesState = API_STATES
      .REQUEST_SUCCESS
  },
  [types.SEND_SMS_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_FAILED](state, err) {
    state.sendSmsWeeklyWorkSchedulesToEmployeesError = err
    state.sendSmsWeeklyWorkSchedulesToEmployeesState = API_STATES
      .REQUEST_ERROR
  },
  // getDepartmentFilterData
  [types.GET_DEPARTMENT_FILTER_BEGIN](state) {
    state.departmentFilterState = API_STATES.REQUEST_PENDING
  },
  [types.GET_DEPARTMENT_FILTER_SUCCESS](state, company) {
    state.departmentFilterState = API_STATES.REQUEST_SUCCESS
    state.departmentFilter = company.departments
    state.departmentFilterError = null
  },
  [types.GET_DEPARTMENT_FILTER_ERROR](state, err) {
    state.departmentFilterState = API_STATES.REQUEST_ERROR
    state.departmentFilterError = err
  },
  [types.UPDATE_FILTER](state, pagination) {
    const merged = merge(state.pagination, pagination)
    state.pagination = {
      ...merged
    }
  }

}

export default mutations
